import React from "react";
import "../styles/layout/OurServices.scss";
import { Stack, Typography, Container, Card } from "@mui/material";
import { Link } from "react-router-dom";

const servicesData = [
  {
    title: "Advanced AI",
    route: "/AdvancedAI",
    items: [
      {
        name: "Data Science",
        icon: "/assets/header/servicesDropDownImages/AdvanceAI/DataScience.png",
        route: "/AI_DataScience",
      },
      {
        name: "Text Analytics",
        icon: "/assets/header/servicesDropDownImages/AdvanceAI/TextAnalytics.png",
        route: "/AI_TextAnalysis",
      },
      {
        name: "Computer Vision",
        icon: "/assets/header/servicesDropDownImages/AdvanceAI/ComputerVision.png",
        route: "/AI_ComputerVision",
      },
      {
        name: "Predictive Analysis",
        icon: "/assets/header/servicesDropDownImages/AdvanceAI/PredictiveAnalysis.png",
        route: "/AI_PredictiveAnalysis",
      },
      {
        name: "Generative AI",
        icon: "/assets/header/servicesDropDownImages/AdvanceAI/GenerativeAI.png",
        route: "/GenerativeAI",
      },
    ],
  },
  {
    title: "Big Data",
    route: "/BigData",
    items: [
      {
        name: "Data Lake",
        icon: "/assets/header/servicesDropDownImages/BigData/DataLake.png",
        route: "/DataLake",
      },
      {
        name: "Data Warehouse",
        icon: "/assets/header/servicesDropDownImages/BigData/DataWarehouse.png",
        route: "/DataWarehouse",
      },
      {
        name: "Data Integration",
        icon: "/assets/header/servicesDropDownImages/BigData/DataIntegration.png",
        route: "/DataIntegration",
      },
    ],
  },
  {
    title: "Data Analytics",
    route: "/DataAnalytics",
    items: [
      {
        name: "Tableau",
        icon: "/assets/header/servicesDropDownImages/DataAnalytics/Tableau.png",
        route: "/Tableau",
      },
      {
        name: "Power BI",
        icon: "/assets/header/servicesDropDownImages/DataAnalytics/PowerBI.png",
        route: "/PowerBI",
      },
    ],
  },
  {
    title: "Product Engineering",
    route: "/ProductEngineering",
    items: [
      {
        name: "Angular Development",
        icon: "/assets/header/servicesDropDownImages/ProductEngineering/Angular.png",
        route: "/Angular",
      },
      {
        name: "React Development",
        icon: "/assets/header/servicesDropDownImages/ProductEngineering/React.png",
        route: "/Reactjs",
      },
      {
        name: "Python Development",
        icon: "/assets/header/servicesDropDownImages/ProductEngineering/Python.png",
        route: "/Python",
      },
    ],
  },
];

const OurServices = () => {
  return (
    <Container
      className="ourservicespage"
      sx={{
        backgroundColor: "#FFC3EA",
        height: "auto",
        maxWidth: "100% !important",
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        gap: "2%",
        backgroundImage:
          'url("/assets/header/servicesDropDownImages/OurServicesPatern.png")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          display: "flex",
          fontFamily: "Orbitron",
          fontSize: { xs: "32px", sm: "45px", md: "70px" },
          fontWeight: "800",
          color: "#000",
          letterSpacing: "2px",
          justifyContent: "center",
          padding: { xs: "8%", sm: "4%" },
          textAlign: "center",
        }}
      >
        Our Services
      </Typography>

      {/* Group services into rows of two */}
      {servicesData
        .reduce((rows, service, index) => {
          if (index % 2 === 0) rows.push([]);
          rows[rows.length - 1].push(service);
          return rows;
        }, [])
        .map((row, rowIndex) => (
          <Stack
            key={rowIndex}
            spacing={2}
            direction={{ xs: "column", sm: "row" }}
            sx={{
              flexWrap: "wrap",
              justifyContent: "center",
              marginBottom: "5%",
              gap: { xs: "16px", sm: "24px" },
            }}
          >
            {row.map((service) => (
              <Card
                key={service.title}
                sx={{
                  width: { xs: "100%", sm: "45%", md: "40%" },
                  display: "flex",
                  alignItems: "center",
                  padding: "2%",
                  flexDirection: "column",
                  borderRadius: "20px",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                }}
              >
                <Link
                  to={service.route}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="outterBox"
                >
                  <Typography
                    className="innerBox"
                    sx={{
                      width: "60%",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: "700",
                      fontSize: { xs: "20px", sm: "25px", md: "30px" },
                      display: "flex",
                      justifyContent: "center",
                      padding: "0 4%",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    {service.title}
                  </Typography>
                </Link>

                <ul
                  className="cardContent"
                  style={{
                    display: "flex",
                    listStyleType: "none",
                    margin: "0",
                    padding: "5% 0 0 0",
                    width: "100%",
                    flexDirection: "column",
                  }}
                >
                  {service.items.map((item) => (
                    <li
                      key={item.name}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        paddingLeft: "5%",
                        width: "100%",
                        alignItems: "center",
                        gap: "5%",
                      }}
                    >
                      <Link
                        to={item.route}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5%",
                          textDecoration: "none",
                          color: "inherit",
                          width: "100%",
                        }}
                      >
                        <img
                          alt={item.name}
                          src={item.icon}
                          className="os-img"
                          style={{
                            width: "30px",
                            height: "30px",
                          }}
                        />
                        <Typography
                          className="cardContentText"
                          sx={{
                            fontSize: { xs: "14px", sm: "18px" },
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.name}
                        </Typography>
                      </Link>
                    </li>
                  ))}
                </ul>
              </Card>
            ))}
          </Stack>
        ))}
    </Container>
  );
};

export default OurServices;
